import axios from './Axios';
const setAuthHeaders = ({ authToken, userID, roleID, appType = 'eFAST' }) => {
  if (authToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }

  if (userID) {
    axios.defaults.headers.common['x-user-id'] = userID;
  } else {
    delete axios.defaults.headers.common['x-user-id'];
  }

  if (roleID) {
    axios.defaults.headers.common['x-role-id'] = roleID;
  } else {
    delete axios.defaults.headers.common['x-role-id'];
  }

  if (appType) {
    axios.defaults.headers.common['x-app-type'] = appType;
  } else {
    delete axios.defaults.headers.common['x-app-type'];
  }
};

export default setAuthHeaders;
